// order.reducer.js
import { orderConstants } from "../actions/constants";

const initState = {
    orders: [],
    orderDetails: {},
    counts: {},
    meta: {},
    mode: "office",
    error: null,
    message: "",
    showAlert: false,
    variantAlert: "success",
    textContent: "",
    loading: false,
    detailsLoading: false,
    actionLoading: false,
};

const getMessage = (payload, fallback = "") => {
    return payload?.message || payload?.error || fallback;
};

const upsertOrder = (orders = [], order) => {
    if (!order?._id) return orders;

    const exists = orders.some((item) => String(item._id) === String(order._id));

    if (!exists) return [order, ...orders];

    return orders.map((item) => {
        return String(item._id) === String(order._id) ? order : item;
    });
};

export default function orderReducer(state = initState, action) {
    switch (action.type) {
        case orderConstants.SET_ORDER_MODE:
            return {
                ...state,
                mode: action.payload || "office",
                orders: [],
                orderDetails: {},
                error: null,
                message: "",
                showAlert: false,
            };

        case orderConstants.ADD_USER_ORDER_REQUEST:
        case orderConstants.ADD_USER_ORDER_WITH_SCREENS_REQUEST:
        case orderConstants.SEARCH_ORDERS_BY_ORDER_NUMBER_REQUEST:
        case orderConstants.UPDATE_ORDER_BY_ID_VISIBLE_REQUEST:
        case orderConstants.GET_USER_ORDER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                showAlert: false,
            };

        case orderConstants.GET_USER_ORDER_DETAILS_REQUEST:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            };

        case orderConstants.CHANGE_ORDER_SCOPE_REQUEST:
        case orderConstants.REQUEST_ORDER_ACCESS_REQUEST:
        case orderConstants.GRANT_ORDER_ACCESS_REQUEST:
        case orderConstants.DECLINE_ORDER_ACCESS_REQUEST:
            return {
                ...state,
                actionLoading: true,
                error: null,
                showAlert: false,
            };

        case orderConstants.ADD_USER_ORDER_SUCCESS:
        case orderConstants.ADD_USER_ORDER_WITH_SCREENS_SUCCESS: {
            const order = action.payload?.order;

            return {
                ...state,
                loading: false,
                orders: order ? upsertOrder(state.orders, order) : state.orders,
                orderDetails: order || state.orderDetails,
                message: getMessage(action.payload, "Заказ сохранён"),
                showAlert: true,
                variantAlert: "success",
            };
        }

        case orderConstants.GET_USER_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                orders: action.payload?.orders || [],
                counts: action.payload?.counts || {},
                meta: action.payload?.meta || {},
                error: null,
            };

        case orderConstants.SEARCH_ORDERS_BY_ORDER_NUMBER_SUCCESS:
            return {
                ...state,
                loading: false,
                orders: action.payload?.orders || [],
                counts: action.payload?.counts || {},
                meta: action.payload?.meta || {},
                message: action.payload?.message || "",
                error: null,
            };

        case orderConstants.GET_USER_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                orderDetails: action.payload?.order || {},
                error: null,
            };

        case orderConstants.UPDATE_ORDER_BY_ID_VISIBLE_SUCCESS: {
            const nextOrder = action.payload?.result || action.payload?.order;

            return {
                ...state,
                loading: false,
                orders: nextOrder
                    ? state.orders.map((item) => String(item._id) === String(nextOrder._id) ? nextOrder : item)
                    : state.orders,
                orderDetails: nextOrder && String(state.orderDetails?._id) === String(nextOrder._id)
                    ? nextOrder
                    : state.orderDetails,
                message: getMessage(action.payload, "Заказ обновлён"),
                showAlert: true,
                variantAlert: "success",
            };
        }

        case orderConstants.CHANGE_ORDER_SCOPE_SUCCESS: {
            const nextOrder = action.payload?.order;

            return {
                ...state,
                actionLoading: false,
                orders: nextOrder
                    ? state.orders.filter((item) => String(item._id) !== String(nextOrder._id))
                    : state.orders,
                orderDetails: nextOrder && String(state.orderDetails?._id) === String(nextOrder._id)
                    ? nextOrder
                    : state.orderDetails,
                message: getMessage(action.payload, "Тип заказа изменён"),
                showAlert: true,
                variantAlert: "success",
            };
        }

        case orderConstants.REQUEST_ORDER_ACCESS_SUCCESS:
        case orderConstants.GRANT_ORDER_ACCESS_SUCCESS:
        case orderConstants.DECLINE_ORDER_ACCESS_SUCCESS: {
            const nextOrder = action.payload?.order;

            return {
                ...state,
                actionLoading: false,
                orders: nextOrder ? upsertOrder(state.orders, nextOrder) : state.orders,
                orderDetails: nextOrder && String(state.orderDetails?._id) === String(nextOrder._id)
                    ? nextOrder
                    : state.orderDetails,
                message: getMessage(action.payload, "Доступ обновлён"),
                showAlert: true,
                variantAlert: "success",
            };
        }

        case orderConstants.ADD_USER_ORDER_FAILURE:
        case orderConstants.ADD_USER_ORDER_WITH_SCREENS_FAILURE:
        case orderConstants.SEARCH_ORDERS_BY_ORDER_NUMBER_FAILURE:
        case orderConstants.UPDATE_ORDER_BY_ID_VISIBLE_FAILURE:
        case orderConstants.GET_USER_ORDER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка",
                message: action.payload?.error || action.payload?.message || "Ошибка",
                showAlert: true,
                variantAlert: "warning",
            };

        case orderConstants.GET_USER_ORDER_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка",
                message: action.payload?.error || action.payload?.message || "Ошибка",
                showAlert: true,
                variantAlert: "warning",
            };

        case orderConstants.CHANGE_ORDER_SCOPE_FAILURE:
        case orderConstants.REQUEST_ORDER_ACCESS_FAILURE:
        case orderConstants.GRANT_ORDER_ACCESS_FAILURE:
        case orderConstants.DECLINE_ORDER_ACCESS_FAILURE:
            return {
                ...state,
                actionLoading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка",
                message: action.payload?.error || action.payload?.message || "Ошибка",
                showAlert: true,
                variantAlert: "warning",
            };

        case orderConstants.CLOSE_ALERT_TO_ORDER_SUCCESS:
            return {
                ...state,
                showAlert: false,
                message: "",
                error: null,
            };

        default:
            return state;
    }
}
export const setCloseAlertOrder = (payload) => ({ type: orderConstants.CLOSE_ALERT_TO_ORDER_SUCCESS, payload });